// Module
var code = `<!-- ko if: visible -->
<div class="svc-page-navigator">
    <div role="button" class="svc-page-navigator__selector svc-page-navigator__button" data-bind="click: togglePageSelector, key2click, attr: { title: pageSelectorCaption }, css: { 'svc-page-navigator__button--pressed': isPopupOpened }">
        <sv-svg-icon class="svc-page-navigator__button-icon" params="iconName: icon, size: 'auto'"></sv-svg-icon>
        <sv-popup params="model: popupModel, cssClass: 'svc-page-navigator__popup'"></sv-popup>
    </div>
    <div>
        <!-- ko foreach: visibleItems -->
        <svc-page-navigator-item params="item: \$data"></svc-page-navigator-item>
        <!-- /ko -->
    </div>
</div>
<!-- /ko -->`;
// Exports
export default code;